module.exports = "https://coursera_assets.s3.amazonaws.com/images/32d83b9606ac646a49c3a8dca088711f.jpg";